import { useEffect } from "react";
import { toast } from "sonner";
import { KursusHeader } from "./kursus/KursusHeader";
import { KursusHero } from "./kursus/KursusHero";
import { UrgencyStrip } from "./kursus/UrgencyStrip";
import { CourseInfoGrid } from "./kursus/CourseInfoGrid";
import { LocationSection } from "./kursus/LocationSection";
import { CoursePurpose } from "./kursus/CoursePurpose";
import { TrainingExperience } from "./kursus/TrainingExperience";
import { RequirementsSection } from "./kursus/RequirementsSection";
import { WhatYouGet } from "./kursus/WhatYouGet";
import { RegistrationForm } from "./kursus/RegistrationForm";
import { FinalCTA } from "./kursus/FinalCTA";
import { KursusFooter } from "./kursus/KursusFooter";
import { MobileStickyCTA } from "./kursus/MobileStickyCTA";
import { FloatingWhatsapp } from "./kursus/FloatingWhatsapp";
import { CONTACT_NAME } from "./kursus/kursusConstants";

const SEO_TITLE = "Kursus Asas Pengawal Peribadi | Bodyguard Sarawak";
const SEO_DESCRIPTION = "Sertai Kursus Asas Pengawal Peribadi anjuran Bodyguard Sarawak. Terhad kepada 20 peserta. Hubungi urusetia untuk maklumat yuran.";
const SEO_KEYWORDS = "kursus bodyguard sarawak, kursus pengawal peribadi sarawak, bodyguard sarawak, kursus keselamatan sarawak, kursus bodyguard kuching, kursus bodyguard lundu";

function setMetaTag(attr, value, content) {
  let tag = document.querySelector(`meta[${attr}="${value}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, value);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function Kursus() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = SEO_TITLE;
    setMetaTag("name", "description", SEO_DESCRIPTION);
    setMetaTag("name", "keywords", SEO_KEYWORDS);
    setMetaTag("property", "og:title", SEO_TITLE);
    setMetaTag("property", "og:description", SEO_DESCRIPTION);
    return () => {
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    if (payment === "paid") {
      toast.success("Pembayaran Billplz berjaya! Terima kasih, pendaftaran anda telah disahkan.", { duration: 8000 });
    } else if (payment === "failed") {
      toast.error("Pembayaran Billplz tidak berjaya. Sila cuba lagi atau pilih Bank Transfer.", { duration: 8000 });
    } else if (payment === "unknown") {
      toast.info(`Status pembayaran tidak dapat disahkan. Sila hubungi ${CONTACT_NAME} melalui WhatsApp.`, { duration: 8000 });
    }
    if (payment) {
      const url = new URL(window.location.href);
      url.searchParams.delete("payment");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  return (
    <div className="kursus-page pb-16 lg:pb-0" data-testid="kursus-page">
      <KursusHeader />
      <KursusHero />
      <UrgencyStrip />
      <CourseInfoGrid />
      <LocationSection />
      <CoursePurpose />
      <TrainingExperience />
      <RequirementsSection />
      <WhatYouGet />
      <RegistrationForm />
      <FinalCTA />
      <KursusFooter />
      <MobileStickyCTA />
      <FloatingWhatsapp />
    </div>
  );
}
